import React, { RefObject } from 'react';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import CheckCircleSolidIcon from '../../../../shared/icons/check-circle-solid-icon';

import './progress-header-item.scss';

interface ProgressHeaderItemProps {
  currentStep: number;
  isActive: boolean;
  isCompleted: boolean;
  linkUrl?: string;
  onStepClick?: (number) => void;
  selectedRef?: RefObject<HTMLLIElement>;
  title: Array<JSX.Element>;
}

function getProgressHeaderItemStyle(
  feature,
  isCompleted,
  isActive,
  isDisabled
) {
  if (
    isCompleted &&
    (feature === 'icon' || (feature === 'title' && isDisabled))
  ) {
    return `${feature} ${feature}-completed`;
  } else if (isActive) {
    return `${feature} ${feature}-active`;
  } else if (!isDisabled) {
    return `${feature} ${feature}-clickable`;
  } else {
    return feature;
  }
}

export default function ProgressHeaderItem(props: ProgressHeaderItemProps) {
  const {
    currentStep,
    isActive,
    isCompleted,
    linkUrl,
    onStepClick,
    selectedRef,
    title
  } = props;
  const isDisabled = !onStepClick && !linkUrl;

  function getRefValue() {
    if (isActive) return selectedRef;
    return null;
  }

  return (
    <li
      className="progress-header-item"
      ref={getRefValue()}
      styleName="container"
    >
      <Button
        href={isDisabled ? undefined : linkUrl}
        isDisabled={isDisabled}
        onClick={() => onStepClick?.(currentStep)}
        styleName={getProgressHeaderItemStyle(
          'step',
          isCompleted,
          isActive,
          isDisabled
        )}
      >
        <Typography
          styleName={getProgressHeaderItemStyle(
            'icon',
            isCompleted,
            isActive,
            isDisabled
          )}
          tag="div"
          weight="black"
        >
          {!isCompleted ? currentStep : ''}
          <div styleName="completed-sign">
            <CheckCircleSolidIcon />
          </div>
        </Typography>
        <Typography
          className="progress-header-item__title-container"
          styleName={getProgressHeaderItemStyle(
            'title',
            isCompleted,
            isActive,
            isDisabled
          )}
          tag="span"
          weight={isActive ? 'black' : ''}
        >
          {title}
        </Typography>
      </Button>
    </li>
  );
}
